<template>
    <div class="one-to-one__section">

        <h2>{{ $t("elements-correspondence") }}</h2>

        <div class="element-group">
            <div class="element">
                <div
                    class="element__icon"
                    aria-hidden="true">

                    <donut
                        class="element__donut"
                        :value="elementsData.pointsperc"
                        :color="partnerElement.color" />

                    <img
                        class="element__icon-svg"
                        :src="partnerElementIcon"
                        alt="" />
                </div>
                <h3 class="element__name">{{ $t(partnerElement.name) }}</h3>
                <p class="element__score">{{ elementsData.pointsperc }}%</p>
            </div>

            <span class="element-group__text">+</span>

            <div class="element">
                <div
                    class="element__icon"
                    aria-hidden="true">

                    <donut
                        class="element__donut"
                        :value="elementsData._pointsperc"
                        :color="userElement.color" />

                    <img
                        class="element__icon-svg"
                        :src="userElementIcon"
                        alt="" />
                </div>
                <h3 class="element__name">{{ $t(userElement.name) }}</h3>
                <p class="element__score">{{ elementsData._pointsperc }}%</p>
            </div>

            <span class="element-group__text">=</span>

            <span class="element-group__text element-group__text--conclusion">{{ capitalize(elementsData.desc) }}</span>

        </div>

        <div class="grid">
            <div class="grid__item desktop--9">
                <h3 class="title--4">{{ capitalize(elementsData.desc1) }} :</h3>
                <p>{{ capitalize(elementsData.desc2) }}</p>
            </div>
        </div>

    </div>
</template>

<script>

import Donut from "@/components/charts/Donut.vue";

import { ELEMENTS } from "@/utils/constants/elements.js";

export default {
    name: "ElementsSection",
    components: {
        "Donut": Donut
    },
    props: {
        elementsData: {
            type: Object,
            required: true
        },
    },
    data () {
        return {};
    },
    computed: {
        partnerElement() {
            return ELEMENTS[this.elementsData.Description];
        },
        userElement() {
            return ELEMENTS[this.elementsData._Description];
        },
        partnerElementIcon() {
            return require(`@/assets/images/artworks/who-i-am/elements/${this.partnerElement.name}.svg`);
        },
        userElementIcon() {
            return require(`@/assets/images/artworks/who-i-am/elements/${this.userElement.name}.svg`);
        },
    },
    mounted: function() {
    },
};

</script>